import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('powerstreamcooperation');
    const { locale } = useRouter();

    const LINK_MAP: any = {
        it: [
            {
                key: 1,
                img: '/responsive/picture/powerstream-cooperation/2_4.png',
                link: 'https://www.netzwelt.de/news/220931-testbericht-ecoflow-powerstream-flexibles-ueberall-balkonkraftwerk-speicher.html',
            },
            {
                key: 2,
                img: '/responsive/picture/powerstream-cooperation/2_1.png',
                link: 'https://www.computerbase.de/2023-07/ecoflow-powerstream-test-balkonkraftwerk-stromspeicher/',
            },
            {
                key: 3,
                img: '/responsive/picture/powerstream-cooperation/2_2.png',
                link: 'https://efahrer.chip.de/news/balkonkraftwerk-mit-speicher-sie-koennen-es-auch-mit-auf-reisen-nehmen_1013188',
            },
            {
                key: 4,
                img: '/responsive/picture/powerstream-cooperation/2_3.png',
                link: 'https://www.giga.de/test/ecoflow-powerstream-im-test-fast-perfektes-balkonkraftwerk-mit-akku-speicher/#lohnt_sich_so_ein_powerstream_balkonkraftwerk',
            },
            {
                key: 5,
                img: '/responsive/picture/powerstream-cooperation/2_h&s.png',
                link: 'https://www.homeandsmart.de/ecoflow-powerstream-test',
            },
        ],
        fr: [
            {
                key: 1,
                img: '/responsive/picture/powerstream-cooperation/2_frd.png',
                link: 'https://www.frandroid.com/survoltes/energie/1773401_nous-avons-teste-le-kit-solaire-ecoflow-powerstream-est-ce-un-bon-investissement',
            },
            {
                key: 2,
                img: '/responsive/picture/powerstream-cooperation/2_tg.png',
                link: 'https://www.tomsguide.fr/test-du-kit-solaire-ecoflow-powerstream-pour-balcon-un-moyen-de-payer-moins-delectricite/',
            },
            {
                key: 3,
                img: '/responsive/picture/powerstream-cooperation/2_mai.png',
                link: 'https://www.maison-et-domotique.com/142572-test-ecoflow-powerstream-optimiser-production-solaire/',
            },
            {
                key: 4,
                img: '/responsive/picture/powerstream-cooperation/2_geek.png',
                link: 'https://www.journaldugeek.com/test/on-a-vraiment-teste-lecoflow-powerstream-voici-les-economies-realisees-sur-notre-facture-delectricite/',
            },
            {
                key: 5,
                img: '/responsive/picture/powerstream-cooperation/2_mac.png',
                link: 'https://www.mac4ever.com/ecotech/178918-test-ecoflow-powerstream-un-onduleur-intelligent-pour-gerer-le-surplus-solaire',
            },
            {
                key: 6,
                img: '/responsive/picture/powerstream-cooperation/2_net.png',
                link: 'https://www.netcost-security.fr/test-produit/193755/test-ecoflow-powerstream-utilisez-et-stockez-lenergie-solaire-jour-et-nuit-pour-votre-maison-appartement/',
            },
        ],
        es: [
            {
                key: 1,
                img: '/responsive/picture/powerstream-cooperation/2_xat.png',
                link: 'https://www.xataka.com/analisis/ecoflow-powerstream-analisis-caracteristicas-precio-especificaciones',
            },
            {
                key: 2,
                img: '/responsive/picture/powerstream-cooperation/2_rz.png',
                link: 'https://www.redeszone.net/analisis/otros-dispositivos/ecoflow-powerstream/',
            },
            {
                key: 3,
                img: '/responsive/picture/powerstream-cooperation/2_pro.png',
                link: 'https://www.profesionalreview.com/2023/07/20/ecoflow-powerstream-review/',
            },
        ],
    };

    return (
        <div className={`powerstream-cooperation-B ${css['powerstream-cooperation-B']}`}>
            <p className="title">{t('secB_title')}</p>
            <div className="icon-wrapper">
                {LINK_MAP[locale]?.map((item: any) => (
                    <Link href={item.link} className="link" key={item.key}>
                        <EFPicture className="icon-1" src={item.img} alt={t('secB_title')} />
                    </Link>
                ))}
            </div>
        </div>
    );
}
